/**
 * @since 2023-07-31
 * @author Francesco Parrella
 * @maintainer Francesco Parrella
 * @copyright AlgoTraders, All rights reserved
 */

import PanelHeader from "components/Shared/PanelHeader";
import ToggleButtonGroupResearch from "components/Shared/ToggleButtonGroupResearch";
import { PiUploadSimpleBold } from "react-icons/pi";
import { Navigate, Outlet, Route, Routes, useNavigate } from "react-router-dom";
import PanelAnalysis from "./PanelAnalysis";
import PanelReports from "./PanelReports";
import PanelScores from "./PanelScores";
import PanelSettings from "./PanelSettings";

const ImportedBuilder = ({
  email,
  menuItem,
  listImportedNames,
  configuration,
  onImportedNameChange,
  isNavBarVisible,
}) => {
  const navigate = useNavigate();

  const goToAnalysisView = () => {
    navigate("analysis", { relative: true });
  };

  const goToReportsView = () => {
    navigate("reports", { relative: true });
  };

  const goToScoresView = () => {
    navigate("scores", { relative: true });
  };

  return (
    <>
      {menuItem && (
        <>
          <PanelHeader
            menuItem={menuItem}
            icon={<PiUploadSimpleBold style={{ fontSize: "30px" }} />}
            toggleButtonGroup={
              <ToggleButtonGroupResearch
                selectedValue={menuItem.ItemView}
                strategyType="imported strategy"
              />
            }
            isNavBarVisible={isNavBarVisible}
          />
          <Routes>
            <Route element={<Outlet />}>
              <Route
                path={"settings"}
                element={
                  <PanelSettings
                    email={email}
                    importedId={menuItem.ItemId}
                    importedName={menuItem.ItemName}
                    listImportedNames={listImportedNames}
                    configuration={configuration}
                    onImportedNameChange={onImportedNameChange}
                    onAnalysisClick={goToAnalysisView}
                  />
                }
              />
              <Route
                path={"analysis"}
                element={
                  <PanelAnalysis
                    email={email}
                    importedId={menuItem.ItemId}
                    importedName={menuItem.ItemName}
                    onScoresClick={goToScoresView}
                  />
                }
              />
              <Route
                path={"reports"}
                element={
                  <PanelReports email={email} importedId={menuItem.ItemId} />
                }
              />
              <Route
                path={"scores"}
                element={
                  <PanelScores
                    email={email}
                    importedId={menuItem.ItemId}
                    onReportsClick={goToReportsView}
                  />
                }
              />
              <Route path="*" element={<Navigate to="settings" />} />
            </Route>
          </Routes>
        </>
      )}
    </>
  );
};
export default ImportedBuilder;
